import { ToastService } from './../../../../../../core/toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { CloseBidService } from '../../services/close-bid.service';

@Component({
  selector: 'app-close-bid',
  templateUrl: './close-bid.component.html',
  styleUrls: ['./close-bid.component.scss']
})
export class CloseBidComponent implements OnInit {

  constructor(
    private closeBidService: CloseBidService,
    private toast: ToastService,
    private dialogRef: MatDialogRef<CloseBidComponent>,
    @Inject(MAT_DIALOG_DATA) public second_hand_supplies_id: string
    ) { }

  ngOnInit(): void {
  }


  closeDialog(status: string){
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  async closeBid(){
    try {
      await this.closeBidService.closeBid({id: this.second_hand_supplies_id});
      this.toast.openSnackBar('Bid closed successfully');
      this.closeDialog('yes');
    } catch(error) {
      this.toast.openSnackBar('Unable to close the bid');
    }
  }

}
